import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { isObservable } from 'rxjs';

/**
 * This pipe allows the input either a plain object or a observable
 */
@Pipe({
  name: 'mixAsync',
  pure: false,
})
export class MixAsyncPipe implements PipeTransform, OnDestroy {
  asyncPipe: AsyncPipe;

  constructor(private ref: ChangeDetectorRef) {
    this.asyncPipe = new AsyncPipe(ref);
  }

  transform(value: any): any {
    if (isObservable(value)) {
      return this.asyncPipe.transform(value);
    } else {
      return value;
    }
  }

  ngOnDestroy() {
    this.asyncPipe.ngOnDestroy();
  }
}
